import {Theme} from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: '2rem 1rem 1rem',
      display: 'flex',
      alignItems: 'center',
      marginTop: 'auto',
    },
    img: {
      marginRight: 15,
    },
  });

export type Styles = WithStyles<typeof styles>;
